import { ComponentPublicInstance, onBeforeUnmount, ref, watch } from "vue";

export default function (elRef: { readonly value: ComponentPublicInstance | null }, handler?: (isIntersecting: boolean) => void) {
  const intersectionObserver = new IntersectionObserver(handleIntersection, {
    threshold: 0.5,
  });
  const isIntersecting = ref(false);

  watch(elRef, () => {
    intersectionObserver.disconnect();

    if (elRef.value) intersectionObserver.observe(elRef.value.$el);
  }, {
    immediate: true,
  });

  onBeforeUnmount(() => {
    intersectionObserver.disconnect();
  });

  function handleIntersection (entries: Array<IntersectionObserverEntry>) {
    const entry = entries.find((entry) => entry.isIntersecting);

    isIntersecting.value = !!entry;
    if (handler) handler(isIntersecting.value);
  }

  return {
    isIntersecting,
  };
}
